interface UserMessageProps {
  message: string;
}

const UserMessage = ({ message }: UserMessageProps) => {
  return (
    <div className="flex justify-end w-full">
      <div className="bg-[#F3F3F3] text-[#171717] px-4 py-3 rounded-2xl max-w-[75%] inline-block" style={{ fontFamily: 'Lexend Deca' }}>
        <p className="text-[13px] font-normal leading-normal whitespace-pre-wrap">{message}</p>
      </div>
    </div>
  );
};

export default UserMessage;
